
import React from 'react';

import Hero from '../components/Hero';
import CertificationSection from '../components/certificationLogos';
import FurnitureCards from '../components/furnitureCard';
import AboutPaab from '../components/aboutPaab';
import Trendings from '../components/trendings';
import Choose from '../components/choose';
import Modern from '../components/modernInterior'


import HomeGlobalSection from "../components/HomeGlobalSection";
import Sectors from '../components/Sectors';


const Home = () => {
  return (
    <div>
      
      <Hero />

      <CertificationSection />

      <AboutPaab />

      <HomeGlobalSection />
      <FurnitureCards />

      <Trendings />

      

      <Choose />

      
      
      <Modern />

      <Sectors/>

    </div>
  );
};

export default Home;